<template>
  <section class="standards" aria-labelledby="standards-title">
    <div class="shell">
      <header v-reveal class="section-head">
        <h2 id="standards-title">Built to production standards</h2>
        <p>
          The same habits I bring to financial systems, applied to every
          project, whatever its size.
        </p>
      </header>
      <ul class="standard-grid">
        <li
          v-for="(item, i) in items"
          :key="item.title"
          v-reveal
          class="standard"
          :style="{ transitionDelay: `${i * 70}ms` }"
        >
          <span class="standard-icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path v-for="d in item.icon" :key="d" :d="d" />
            </svg>
          </span>
          <h3>{{ item.title }}</h3>
          <p>{{ item.body }}</p>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
export default {
  name: "StandardsSection",
  data: () => ({
    items: [
      {
        title: "Secure by default",
        body: "Least-privilege access, encrypted connections, and secrets kept out of code.",
        // shield with a tick
        icon: ["M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6z", "M9 12l2 2 4-4"],
      },
      {
        title: "Tested and reliable",
        body: "Automated tests, error handling and retries, so jobs recover instead of failing silently.",
        // circular arrows
        icon: ["M20 11a8 8 0 0 0-14.3-4.9L4 8", "M4 4v4h4", "M4 13a8 8 0 0 0 14.3 4.9L20 16", "M20 20v-4h-4"],
      },
      {
        title: "Documented handover",
        body: "Clear documentation and a walkthrough, so your team knows how everything works.",
        // document with lines
        icon: ["M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z", "M14 3v5h5", "M9 13h6", "M9 17h4"],
      },
      {
        title: "Direct communication",
        body: "You talk to the engineer doing the work, with progress shown early and often.",
        // speech bubble
        icon: ["M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z", "M8.5 12h.01", "M12 12h.01", "M15.5 12h.01"],
      },
    ],
  }),
};
</script>
